import { FC } from 'react';
import ExclusionDialog from '../components/ExclusionDialog';
import { Exclusion, ExclusionTypeRaw } from '../types/exclusion-types';

const ExclusionModal: FC<React.PropsWithChildren<ExclusionModalProps>> = ({
  exclusion,
  open,
}) => {
  return (
    <ExclusionDialog
      open={open}
      dialogTitle={
        exclusion?.exclusionType === ExclusionTypeRaw.alert
          ? 'Remove Exclusion'
          : exclusion?.exclusionType === ExclusionTypeRaw.application
          ? 'Relevant App'
          : 'Enable Policy'
      }
      exclusion={exclusion}
    />
  );
};

export interface ExclusionModalProps {
  exclusion: Exclusion | null;
  open: boolean;
}

export default ExclusionModal;
